import React, {useState, useEffect} from 'react'
import { useDispatch } from 'react-redux';
import {siteUrl, hostUrl } from '../../constants/global';
import allActions from '../../actions/index';

const CertificateDownload = () => {
    const dispatch = useDispatch();

    const [eligibile, setEligible] = useState(false);

    function downloadcertificate(event){
        event.currentTarget.disabled = true;
        event.currentTarget.setAttribute('id','current-loading');
        event.currentTarget.innerHTML = "<span class='material-icons-outlined spin'>motion_photos_on</span> Downloading...";

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 
            'POST' : '/resource HTTP/1.1',
            'Authorization': token,
            'Host' : hostUrl,
            'username' : username
            }
         };

        fetch(siteUrl+'/generate.php',requestOptions)
        .then((response) => response.blob())
        .then(function(blob){ 
            //console.log(blob, "Generate data");
            // Create blob link to download
            const url = window.URL.createObjectURL(
            new Blob([blob]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.download = storageData.first_name+' '+storageData.last_name+'-certificate.pdf';
    
            // Append to html link element page
            document.body.appendChild(link);
    
            // Start download
            link.click();

            document.getElementById("current-loading").removeAttribute("disabled");
            const currentElement = document.getElementById('current-loading');
            // ✅ Remove ID attribute
            currentElement.innerHTML = '<span class="material-icons-outlined">download</span> Download Certificate';
            currentElement.removeAttribute('id');
    
            // Clean up and remove the link
        }).catch(rejected => {

        });
    }

    /*********
     * Open Faq popup for certification
     * **********/
    function openFaqPopupForCertification(event){
       dispatch( allActions.ModalPopup.showPopup({ popupname:'faq-certificate'}));
    }

    useEffect(() => {

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        var myHeaders = new Headers();
        var formdata = new FormData();
        formdata.append("username", storageData.user_email);

        var requestOptionsCertificate = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };

        fetch(siteUrl+'/community-rest-functions.php?action=check_user_eligible_for_certificate',requestOptionsCertificate)
        .then((response) => response.json())
        .then(function(actualData){ 
            //console.log(actualData+"actualsdsdfds datac");
        if(actualData.message===true){
            if(storageData.user_email!="VIP@CIISUMMIT.COM"){
                setEligible(true);
            }
        }
        // Clean up and remove the link
        }).catch(rejected => {

        });


    },[]);

    var CertificateButton = () => { 
        return <button className="download-certificate" onClick={(event) => downloadcertificate(event)}><span className="material-icons-outlined">download</span> Download Certificate</button>
    }

    var CertificateButtonDisable = () => { 
        return <button className="download-certificate disable" onClick={(event) => openFaqPopupForCertification(event)}><span className="material-icons-outlined">download</span> Download Certificate</button>
    }

    return (
        <>
            {eligibile==true && <CertificateButton />}
            {/* {eligibile==false && <CertificateButtonDisable />} */}
        </>
    )
}

export default CertificateDownload
